// ithelps - markus - product migration -> create description inkl. pflege icons
jQuery( document ).ready(function() {
  
  // if product details site
  if (jQuery('.template-product').length) {
    
    // if migrate products
    if( jQuery('.desc-outer').length ){

      var carebox = jQuery('.care-box'); 
      var pflegebox = jQuery('.pflege-box');
      
      if( jQuery(pflegebox)){
        if( jQuery(carebox) ){
          // move pflege data 
          jQuery('.care-text').append( jQuery(pflegebox) );
        }
      }
    }
  }
});

// ithelps - markus
// create accordion and pflege icons (migrate products with html struct)
// the titel of pflege text is different to logic of new products, see below for new description
jQuery( document ).ready(function() {
  
  // check if care-box and pflege text
  if (jQuery('.care-box').length) {
    if (jQuery('.pflege-text').length) {
      
      
      jQuery('.pflege-text').each(function (key, value) {
        // GET TEXT
        var text = jQuery(value).text();
        // SET TEXT TO TOOLTIP
        jQuery(this).prev().attr('title', text);
        if (text == "30° SCHONWASCHGANG")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/2_30_Schonwaschgang.png?v=1695277854)', });
        else if (text == "30° SPEZIALSCHONWASCHGANG")
          jQuery(this).prev().css({ 'background-image': 'urlhttps://cdn.shopify.com/s/files/1/0797/4800/6210/files/13_Handwaesche_Schonwaschgang.png?v=1695277854)', });
        else if (text == "30° NORMALWASCHGANG")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/1_30_Normalwaschgang.png?v=1695277854)', });
        else if (text == "CHEMISCHE REINIGUNG - SCHONEND REINIGEN MIT PERCHLORETHYLEN")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/9_Trockenreinigung_sensitiv_P.png?v=1695277854)', });
        else if (text == "CHEMISCHE REINIGUNG - REINIGEN MIT PERCHLORETHYLEN")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/8_Trockenreinigung_P.png?v=1695277854)', });
        else if (text == "CHEMISCHE REINIGUNG - SCHONEND REINIGEN MIT KOHLENWASSERSTOFFLÖSUNGSMITTEL")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/6_Trockenreinigung_sensitiv_F.png?v=1695277854)', });
        else if (text == "HANDWÄSCHE")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/11_Handwaesche.png?v=1695277854)', });
        else if (text == "LIEGEND TROCKNEN")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/16_Liegend_trocknen.png?v=1695277854)', });
        else if (text == "KEINE CHEMISCHE REINIGUNG MÖGLICH")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/15_keine_Chemische_Reinigung_moeglich.png?v=1695277854)', });
        else if (text == "MÄSSIG HEISS BÜGELN")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/17_maessig_heiss_buegeln.png?v=1695277854)', });
        else if (text == "NASSREINIGUNG - SCHONENDE PROFESSIONELLE NASSREINIGUNG")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/19_Nassreinigung_sensitiv.png?v=1695277854)', });
        else if (text == "NICHT WASCHEN")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/26_nicht_waschen.png?v=1695277854)', });
        else if (text == "NICHT BÜGELN")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/22_nicht_buegeln.png?v=1695277854)', });
        else if (text == "NICHT BLEICHEN")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/21_nicht_bleichen.png?v=1695277854)', });
        else if (text == "NICHT HEISS BÜGELN, VORSICHT BEIM BÜGELN MIT DAMPF")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/23_nicht_heiss_buegeln_Vorsicht_beim_Buegeln_mi_Dampf.png?v=1695277854)', });
        else if (text == "NASSREINIGUNG - SEHR SCHONENDE PROFESSIONELLE NASSREINIGUNG")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/20_Nassreinigung_super_sensitiv.png?v=1695277854)', });
        else if (text == "TROCKNEN MIT REDUZIERTER THERMISCHER BEANSPRUCHUNG")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/28_trocknen_mit_reduzierter_thermischer_Belastung.png?v=1695277854)', });
        else if (text == "TROCKNEN IM TUMBLER NICHT MÖGLICH")
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/24_Trocknen_im_Tumbler_nicht_moeglich.png?v=1695277854)', });
        else
          jQuery(this).prev().css({ 'background-image': 'url(https://cdn.shopify.com/s/files/1/0571/6590/6108/t/2/assets/waschsymbol-default.png?v=1627977624)', });
        // hide item
        jQuery(value).css('opacity', '0');
      });
    }
  }
});

// ithelps - markus
// create accordion and pflege icons (manuel description)
// Titel:			- h5
// Text: 			- p
// Pflege (numbers) - h6
jQuery(document).ready(function () {

  
  // IF PRODUCT DESC NOT FROM MIGRATION (manual fill description)
  if (!jQuery('.desc-outer').length) {
  
    // IF H6 -> CREATE FROM MUBERS PFLEGE ICONS
    if (jQuery('.accordion__content h6').length) {
  
  
        var waschElement = {
            1: '<div class="pflege-item"><div class="pflege-icon" title="30°C / 85°F - normal washing cycle" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/1_30_Normalwaschgang.png?v=1695277854);"></div><div class="pflege-text"><p>30°C / 85°F - normal washing cycle</p></div></div>',
            2: '<div class="pflege-item"><div class="pflege-icon" title="30°C / 85°F - gentle washing cycle" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/2_30_Schonwaschgang.png?v=1695277854);"></div><div class="pflege-text"><p>30°C / 85°F - gentle washing cycle</p></div></div>',
            3: '<div class="pflege-item"><div class="pflege-icon" title="40°C / 105°F - normal washing cycle" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/3_40_Normalwaschgang.png?v=1695277854);"></div><div class="pflege-text"><p>40°C / 105°F - normal washing cycle</p></div></div>',
            4: '<div class="pflege-item"><div class="pflege-icon" title="40°C / 105°F - gentle washing cycle" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/4_40_Schonwaschgang.png?v=1695277854);"></div><div class="pflege-text"><p>40°C / 105°F - gentle washing cycle</p></div></div>',
            5: '<div class="pflege-item"><div class="pflege-icon" title="40°C / 105°F - special gentle washing cycle" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/5_40_Spezialschonwaschgang.png?v=1695277854);"></div><div class="pflege-text"><p>40°C / 105°F special gentle washing cycle</p></div></div>',
            6: '<div class="pflege-item"><div class="pflege-icon" title="Dry cleaning sensitive" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/6_Trockenreinigung_sensitiv_F.png?v=1695277854);"></div><div class="pflege-text"><p>Dry cleaning sensitive</p></div></div>',
            7: '<div class="pflege-item"><div class="pflege-icon" title="Dry cleaning" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/7_Trockenreinigung_F.png?v=1695277854);"></div><div class="pflege-text"><p>Dry cleaning</p></div></div>',
            8: '<div class="pflege-item"><div class="pflege-icon" title="Dry cleaning" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/8_Trockenreinigung_P.png?v=1695277854);"></div><div class="pflege-text"><p>Dry cleaning</p></div></div>',
            9: '<div class="pflege-item"><div class="pflege-icon" title="Dry cleaning sensitive" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/9_Trockenreinigung_sensitiv_P.png?v=1695277854);"></div><div class="pflege-text"><p>Dry cleaning sensitive</p></div></div>',
            10: '<div class="pflege-item"><div class="pflege-icon" title="Chlorine and oxygen bleaching permissible" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/10_Chlor-_und_Sauerstoffbleiche_zulaessig.png?v=1695277854);"></div><div class="pflege-text"><p>Chlorine and oxygen bleaching permissible</p></div></div>',
            11: '<div class="pflege-item"><div class="pflege-icon" title="Hand wash" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/11_Handwaesche.png?v=1695277854);"></div><div class="pflege-text"><p>Hand wash</p></div></div>',
            12: '<div class="pflege-item"><div class="pflege-icon" title="Hand wash at 30°C / 85°F" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/12_Handwaesche_bei_30.png?v=1695277854);"></div><div class="pflege-text"><p>Hand wash at 30°C / 85°F</p></div></div>',
            13: '<div class="pflege-item"><div class="pflege-icon" title="Hand wash gentle cycle at 30°C / 85°F" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/13_Handwaesche_Schonwaschgang.png?v=1695277854);"></div><div class="pflege-text"><p>Hand wash gentle cycle at 30°C / 85°F</p></div></div>',
            14: '<div class="pflege-item"><div class="pflege-icon" title="hot ironing" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/14_heiss_buegeln.png?v=1695277854);"></div><div class="pflege-text"><p>hot ironing</p></div></div>',
            15: '<div class="pflege-item"><div class="pflege-icon" title="No dry cleaning possible" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/15_keine_Chemische_Reinigung_moeglich.png?v=1695277854);"></div><div class="pflege-text"><p>No dry cleaning possible></p></div></div>',
            16: '<div class="pflege-item"><div class="pflege-icon" title="dry flat" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/16_Liegend_trocknen.png?v=1695277854);"></div><div class="pflege-text"><p>dry flat</p></div></div>',
            17: '<div class="pflege-item"><div class="pflege-icon" title="moderately hot ironing" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/17_maessig_heiss_buegeln.png?v=1695277854);"></div><div class="pflege-text"><p>moderately hot ironing</p></div></div>',
            18: '<div class="pflege-item"><div class="pflege-icon" title="Wet cleaning system" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/18_Nassreinigung.png?v=1695277854);"></div><div class="pflege-text"><p>Wet cleaning system</p></div></div>',
            19: '<div class="pflege-item"><div class="pflege-icon" title="Wet cleaning sensitive" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/19_Nassreinigung_sensitiv.png?v=1695277854);"></div><div class="pflege-text"><p>Wet cleaning sensitive</p></div></div>',
            20: '<div class="pflege-item"><div class="pflege-icon" title="Wet cleaning super sensitive" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/20_Nassreinigung_super_sensitiv.png?v=1695277854);"></div><div class="pflege-text"><p>Wet cleaning super sensitive</p></div></div>',
            21: '<div class="pflege-item"><div class="pflege-icon" title="do not bleach" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/21_nicht_bleichen.png?v=1695277854);"></div><div class="pflege-text"><p>do not bleach</p></div></div>',
            22: '<div class="pflege-item"><div class="pflege-icon" title="do not iron" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/22_nicht_buegeln.png?v=1695277854);"></div><div class="pflege-text"><p>do not iron</p></div></div>',
            23: '<div class="pflege-item"><div class="pflege-icon" title="do not iron hot Caution when ironing with steam" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/23_nicht_heiss_buegeln_Vorsicht_beim_Buegeln_mi_Dampf.png?v=1695277854);"></div><div class="pflege-text"><p>do not iron hot Caution when ironing with steam</p></div></div>',
            24: '<div class="pflege-item"><div class="pflege-icon" title="Drying in tumbler not possible" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/24_Trocknen_im_Tumbler_nicht_moeglich.png?v=1695277854);"></div><div class="pflege-text"><p>Drying in tumbler not possible</p></div></div>',
            25: '<div class="pflege-item"><div class="pflege-icon" title="no wet cleaning possible" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/25_keine_Nassreinigung_moeglich.png?v=1695277854);"></div><div class="pflege-text"><p>no wet cleaning possible</p></div></div>',
            26: '<div class="pflege-item"><div class="pflege-icon" title="do not wash" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/26_nicht_waschen.png?v=1695277854);"></div><div class="pflege-text"><p>do not wash</p></div></div>',
            27: '<div class="pflege-item"><div class="pflege-icon" title="only oxygen bleaching permissible/no chlorine bleaching" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/27_nur_Sauerstoffbleichezulaessig_keine_Chlorbleiche.png?v=1695277854);"></div><div class="pflege-text"><p>only oxygen bleaching permissible/no chlorine bleaching</p></div></div>',
            28: '<div class="pflege-item"><div class="pflege-icon" title="drying with reduced thermal load" style="background-image: url(https://cdn.shopify.com/s/files/1/0797/4800/6210/files/28_trocknen_mit_reduzierter_thermischer_Belastung.png?v=1695277854);"></div><div class="pflege-text"><p>drying with reduced thermal load</p></div></div>',
            29: '<div class="pflege-item"><div class="pflege-icon" title="Drying with normal thermal load" style="background-image: url(https://cdn.shopify.com/s/files/1/0571/6590/6108/t/4/assets/waschsymbol-trocknen.png?v=1628607618);"></div><div class="pflege-text"><p>Drying with normal thermal load</p></div></div>'
        }
  
  
  
        // CREATE ARR WITH NUMBER TEXT
        var pflegeNrList = jQuery('.rte h6').text();
        var pflegeNrArr = pflegeNrList.split(",");
  
        // IF PFLEGENR > 0
        if (pflegeNrArr.length > 0) {
  
            // PFLEGE HTML
            var html = '<div class="pflege-box custom"><div class="pflege-box-inner">';
  
            // ADD HTML EACH NUMBER
            jQuery(pflegeNrArr).each(function (key, value) {
                var pflegeNr = jQuery.trim(value);
                html += waschElement[pflegeNr];
            });
  
            // ADD END OF HTML
            html += '</div></div></div>';
  
  
            // APPEND PFLEGE HTML TO PFLEGE CONTAINER
            jQuery('.accordion__content h6').html(html);
        }
    }
  }
});

/* ********** */

// Get the modal
if(document.getElementById("myModal-ithelps")) {
  var modal = document.getElementById("myModal-ithelps");  
  var modal2 = document.getElementById("myModal-ithelps-2");

  // Get the button that opens the modal
  var btn = document.getElementById("myBtn-ithelps");
  var btn2 = document.getElementById("myBtn-ithelps-2");

  // Get the <span> element that closes the modal
  // var span = document.getElementsByClassName("close")[0];
  var span = document.querySelectorAll(".close");

  // When the user clicks on the button, open the modal
  btn.onclick = function() {
    modal.style.display = "block";
  }

  btn2.onclick = function() {
    modal2.style.display = "block";
    modal2.style.zIndex = "2";
  }

  // When the user clicks on <span> (x), close the modal
  /*span.onclick = function() {
    modal.style.display = "none";
  }*/

  span.forEach(el => {
    el.addEventListener("click", () => {
      modal.style.display = "none"
      modal2.style.display = "none"
    })
  })

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      modal2.style.display = "none";
    }
  }
}

// Get the contact form modal
if(document.getElementById("myModal-ithelps-contact")) {
  var modalContact = document.getElementById("myModal-ithelps-contact");  

  // Get the button that opens the modal
  var btnContact = document.getElementById("myBtn-ithelps-contact");

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close-contact")[0];

  // When the user clicks on the button, open the modal
  btnContact.onclick = function() {
    modalContact.style.display = "block";
  }

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modalContact.style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modalContact.style.display = "none";
    }
  }
}

if(window.location.href.includes("contact_posted=true")) {
  if(document.getElementById("myModal-ithelps-contact")) {
    var modalContact = document.getElementById("myModal-ithelps-contact");  
    modalContact.style.display = "block";
  }
}


/* 
ithelps - 29.08.2023 
Show hidden swatches
*/
window.addEventListener("load", (event) => {
  
  // Get all show swatches link
  const showSwatchesLinks = document.querySelectorAll("#mit-show-hidden-swatches");

  // Add event listener for each one of them
  showSwatchesLinks.forEach(swatchLink => {
    // Event listener
    swatchLink.addEventListener("click", e=> {

    // Prevent default behaviour
    e.preventDefault();

    // Get all hidden swatches and display them
    const parentSwatchesList = swatchLink.parentElement.parentElement;
    parentSwatchesList.querySelectorAll('.product-swatches-options__item[data-visible="hidden"]').forEach(swatch => {
      swatch.style.display = "block";
    })

    // Hide show swatches link
    swatchLink.style.display = "none";
    })
  })

  /* Display appropriate image for swatches */
  document.querySelectorAll(".product-swatches-options__list li").forEach(color => {
    color.addEventListener("click", (e) => {
      
        let prodId = e.target.getAttribute("data-prod-id")
        let prodValue = e.target.getAttribute("data-option-value")

        let primaryImg = document.querySelector(`img[data-product-id="${prodId}"][data-option-2="${prodValue}"][data-pos-alt="false"]`)
        let primaryImgSrc = primaryImg.getAttribute("src");
        let secondaryImg = document.querySelector(`img[data-product-id="${prodId}"][data-option-2="${prodValue}"][data-pos-alt="true"]`)
        let secondaryImgSrc = secondaryImg.getAttribute("src");

        document.querySelector(`div[data-prod-id="${prodId}"] .product-item__image--one > img`).src = primaryImgSrc
        document.querySelector(`div[data-prod-id="${prodId}"] .product-item__image--one > img`).removeAttribute("srcset")
        document.querySelector(`div[data-prod-id="${prodId}"] .product-item__image--two > img`).src = secondaryImgSrc
        document.querySelector(`div[data-prod-id="${prodId}"] .product-item__image--two > img`).removeAttribute("srcset")

    })
})

  
});


/* Customize look section */
window.addEventListener("load", (event) => {
  if(document.querySelector(".mit-productitem-img-secondary")) {
    document.querySelectorAll(".mit-productitem-img-secondary").forEach(secondary => {

      secondary.addEventListener("mouseover", () => {
          secondary.parentElement.querySelector("img").style.opacity = "0"
      })
  
          secondary.addEventListener("mouseleave", () => {
          secondary.parentElement.querySelector("img").style.opacity = "1"
      })
    
    })
  }

});


/* 
13.05.2025
*/

// Daniel - itheps - 18.03.2025
// Size per swatch JS
document.addEventListener('DOMContentLoaded', function() {
  // Initialize size availability display
  initSizeAvailability();
  
  // Handle click events on color swatches (removed hover events)
  const swatches = document.querySelectorAll('.product-swatches-options__item--swatch');
  
  swatches.forEach(swatch => {
    // Use click instead of hover
    swatch.addEventListener('click', handleSwatchClick);
  });
  
  // Handle "show more swatches" click
  const showMoreButtons = document.querySelectorAll('#mit-show-hidden-swatches');
  showMoreButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productId = this.closest('.product-item').getAttribute('data-prod-id');
      const hiddenSwatches = document.querySelectorAll(`[data-prod-id="${productId}"][data-visible="hidden"]`);
      
      hiddenSwatches.forEach(swatch => {
        swatch.setAttribute('data-visible', 'visible');
        swatch.style.display = 'inline-block';
      });
      
      this.style.display = 'none';
    });
  });
});

function initSizeAvailability() { 
  // Initially hide all size availability elements
  document.querySelectorAll('.product-item__size-availability').forEach(container => {
    container.style.display = 'none';
  });
  
  document.querySelectorAll('.size-availability__color').forEach(el => {
    el.style.display = 'none';
  });
}

function handleSwatchClick(e) {
  e.preventDefault();
  const productId = this.getAttribute('data-prod-id');
  const colorValue = this.getAttribute('data-option-value');
  
  if (!colorValue) {
    return;
  }
  
  // Get the availability container
  const availabilityContainer = document.querySelector(`.product-item__size-availability[data-product-id="${productId}"]`);
  
  if (availabilityContainer) {
    // First check if the container has content
    if (availabilityContainer.children.length === 0) {
      return;
    }
    
    // Make all swatches look inactive
    const allSwatches = document.querySelectorAll(`[data-prod-id="${productId}"].product-swatches-options__item--swatch`);
    allSwatches.forEach(swatch => {
      swatch.classList.remove('active-swatch');
    });
    
    // Toggle the container visibility
    const isCurrentlyVisible = availabilityContainer.classList.contains('is-visible');
    
    if (isCurrentlyVisible && availabilityContainer.getAttribute('data-current-color') === colorValue) {
      // If clicking the same color again, hide it
      availabilityContainer.classList.remove('is-visible');
      availabilityContainer.style.display = 'none';
      return;
    }
    
    // Mark this swatch as active
    this.classList.add('active-swatch');
    
    // Position the container as a relative element below the swatches section
    positionAvailabilityContainerRelative(availabilityContainer, this);
    
    // Show the container
    availabilityContainer.classList.add('is-visible');
    availabilityContainer.style.display = 'flex';
    availabilityContainer.setAttribute('data-current-color', colorValue);
    
    // Hide all color sections
    availabilityContainer.querySelectorAll('.size-availability__color').forEach(el => {
      el.style.display = 'none';
    });
    
    // Find color section using multiple approaches for reliability
    let colorSection = findColorSection(availabilityContainer, colorValue);
    
    if (colorSection) {
      colorSection.style.display = 'block';
      
      // Log all sizes for this color
      const allSizes = colorSection.querySelectorAll('.size-availability__item');
      
      for (const sizeItem of allSizes) {
        const size = sizeItem.textContent.trim();
        const variantId = sizeItem.getAttribute('data-variant-id');
        const inventory = sizeItem.getAttribute('data-inventory');
        const isAvailable = sizeItem.classList.contains('available');
      }
    } else {
      // As a fallback, show the first color section if no matching one is found
      const firstColorSection = availabilityContainer.querySelector('.size-availability__color');
      if (firstColorSection) {
        firstColorSection.style.display = 'block';
      }
    }
  }
}

// Helper function to find color section with different approaches
function findColorSection(container, colorValue) {
  // 1. Try exact match first
  let colorSection = container.querySelector(`.size-availability__color[data-color="${colorValue}"]`);
  
  // 2. If that fails, try with encoding
  if (!colorSection) {
    const encodedColor = encodeURIComponent(colorValue);
    colorSection = container.querySelector(`.size-availability__color[data-color="${encodedColor}"]`);
  }
  
  // 3. Try a case-insensitive match as a fallback
  if (!colorSection) {
    const allColorSections = container.querySelectorAll('.size-availability__color');
    for (const section of allColorSections) {
      const sectionColor = section.getAttribute('data-color');
      if (sectionColor && sectionColor.toLowerCase() === colorValue.toLowerCase()) {
        colorSection = section;
        break;
      }
    }
  }
  
  // 4. Special check for colors with slashes or special characters
  if (!colorSection) {
    const normalizedColor = colorValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    const allColorSections = container.querySelectorAll('.size-availability__color');
    
    for (const section of allColorSections) {
      const sectionColor = section.getAttribute('data-color');
      if (sectionColor) {
        const normalizedSectionColor = sectionColor.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        if (normalizedColor === normalizedSectionColor) {
          colorSection = section;
          break;
        }
      }
    }
  }
  
  return colorSection;
}

// Position function for overlaying on the image
function positionAvailabilityContainerRelative(container, swatch) {
  // Find the product media element
  const productItem = swatch.closest('.product-item');
  const productMedia = productItem.querySelector('.product-item__media');
  
  if (productMedia) {
    // Remove the container from its current position if needed
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
    
    // Add the container to the product media element
    productMedia.appendChild(container);
  }
}

function handleSwatchHover(e) {
  const productId = this.getAttribute('data-prod-id');
  const colorValue = this.getAttribute('data-option-value');
  
  if (!colorValue) {
    return;
  }
  
  // Show the size availability on hover
  const availabilityContainer = document.querySelector(`.product-item__size-availability[data-product-id="${productId}"]`);
  
  if (availabilityContainer) {
    // First check if the container has content
    if (availabilityContainer.children.length === 0) {
      return;
    }
    
    // Position the container near the swatch
    positionAvailabilityContainer(availabilityContainer, this);
    
    // Show the container
    availabilityContainer.style.display = 'block';
    
    // Hide all color sections
    availabilityContainer.querySelectorAll('.size-availability__color').forEach(el => {
      el.style.display = 'none';
    });
    
    // Find color section using multiple approaches for reliability
    let colorSection = null;
    
    // 1. Try exact match first
    colorSection = availabilityContainer.querySelector(`.size-availability__color[data-color="${colorValue}"]`);
    
    // 2. If that fails, try with encoding
    if (!colorSection) {
      const encodedColor = encodeURIComponent(colorValue);
      colorSection = availabilityContainer.querySelector(`.size-availability__color[data-color="${encodedColor}"]`);
    }
    
    // 3. Try a case-insensitive match as a fallback
    if (!colorSection) {
      const allColorSections = availabilityContainer.querySelectorAll('.size-availability__color');
      for (const section of allColorSections) {
        const sectionColor = section.getAttribute('data-color');
        if (sectionColor && sectionColor.toLowerCase() === colorValue.toLowerCase()) {
          colorSection = section;
          break;
        }
      }
    }
    
    // 4. Special check for colors with slashes or special characters
    if (!colorSection) {
      const normalizedColor = colorValue.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      const allColorSections = availabilityContainer.querySelectorAll('.size-availability__color');
      
      for (const section of allColorSections) {
        const sectionColor = section.getAttribute('data-color');
        if (sectionColor) {
          const normalizedSectionColor = sectionColor.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
          if (normalizedColor === normalizedSectionColor) {
            colorSection = section;
            break;
          }
        }
      }
    }
    
    if (colorSection) {
      colorSection.style.display = 'block';
      
      // Logging specific info about the 0/XS size if present
      const specialSize = '0/XS';
      const specialSizeElement = colorSection.querySelector(`.size-availability__item[data-size="${specialSize}"]`);
      
      if (specialSizeElement) {
        const variantId = specialSizeElement.getAttribute('data-variant-id');
        const inventory = specialSizeElement.getAttribute('data-inventory');
        const isAvailable = specialSizeElement.classList.contains('available');
      }
      
      // Log all sizes for this color
      const allSizes = colorSection.querySelectorAll('.size-availability__item');
      
      for (const sizeItem of allSizes) {
        const size = sizeItem.textContent.trim();
        const variantId = sizeItem.getAttribute('data-variant-id');
        const inventory = sizeItem.getAttribute('data-inventory');
        const isAvailable = sizeItem.classList.contains('available');
      }
    } else {
      // As a fallback, show the first color section if no matching one is found
      const firstColorSection = availabilityContainer.querySelector('.size-availability__color');
      if (firstColorSection) {
        firstColorSection.style.display = 'block';
      }
    }
  }
}

function handleSwatchLeave(e) {
  // Use a timeout to prevent flickering when moving between swatches
  setTimeout(() => {
    const productId = this.getAttribute('data-prod-id');
    const availabilityContainer = document.querySelector(`.product-item__size-availability[data-product-id="${productId}"]`);
    
    if (availabilityContainer && !availabilityContainer.matches(':hover')) {
      availabilityContainer.style.display = 'none';
    }
  }, 200);
}

function positionAvailabilityContainer(container, swatch) {
  const swatchRect = swatch.getBoundingClientRect();
  const containerParent = swatch.closest('.product-item');
  
  if (containerParent) {
    // Append the container to the product item if it's not already there
    if (!containerParent.contains(container)) {
      containerParent.appendChild(container);
    }
    
    // Check if container should be positioned to avoid going off-screen
    const viewportWidth = window.innerWidth;
    
    // Position the container below and aligned with the swatch
    const parentRect = containerParent.getBoundingClientRect();
    const topPosition = swatchRect.bottom - parentRect.top + 5;
    let leftPosition = swatchRect.left - parentRect.left;
    
    // Adjust horizontal position if it would go off-screen
    const containerWidth = 200; // Width from CSS
    if (swatchRect.left + containerWidth > viewportWidth) {
      leftPosition = Math.max(0, viewportWidth - containerWidth - parentRect.left - 10);
    }
    
    // Set the position
    container.style.top = `${topPosition}px`;
    container.style.left = `${leftPosition}px`;
    
    // Make sure the container has its display set properly
    if (container.style.display !== 'block') {
      container.style.display = 'block';
    }
    
  }
}


// JavaScript to handle swatch clicks and update product URLs
document.addEventListener('DOMContentLoaded', function() {
  // Initialize event listeners for all swatches
  initializeSwatchListeners();
  
  // Also handle the "show more" swatches functionality
  initializeShowMoreSwatches();
});

function initializeSwatchListeners() {
  // Get all swatch items
  const swatchItems = document.querySelectorAll('.product-swatches-options__item--swatch');

  // Add click event listener to each swatch
  swatchItems.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get the product container
      const productId = this.getAttribute('data-prod-id');
      const productContainer = document.querySelector(`[data-prod-id="${productId}"]`);
      
      if (!productContainer) return;
      
      // Get variant URL from the swatch
      const variantUrl = this.getAttribute('data-variant-url');
      
      if (!variantUrl) return;
      
      // Update all links in this product container
      updateProductLinks(productContainer, variantUrl);
      
      // Visual indication that this swatch is selected
      highlightSelectedSwatch(productContainer, this);
    });
  });
}

function updateProductLinks(productContainer, variantUrl) {
  // Update main product link
  const productLink = productContainer.querySelector('[data-product-link]');
  if (productLink) {
    productLink.setAttribute('href', variantUrl);
  }
  
  // Update product title link
  const titleLink = productContainer.querySelector('[data-product-title-link]');
  if (titleLink) {
    titleLink.setAttribute('href', variantUrl);
  }
  
  // Update quick view buttons if they exist
  const quickViewLinks = productContainer.querySelectorAll('[data-quick-view-link], [data-quick-view-button], [data-quick-view-beneath]');
  quickViewLinks.forEach(link => {
    link.setAttribute('href', variantUrl);
  });
}

function highlightSelectedSwatch(productContainer, selectedSwatch) {
  // Remove highlight from all swatches in this product
  const allSwatches = productContainer.querySelectorAll('.product-swatches-options__item--swatch');
  allSwatches.forEach(swatch => {
    swatch.classList.remove('selected');
    // Optional: Remove any custom styling you might add
    swatch.style.border = '';
  });
  
  // Add highlight to selected swatch
  selectedSwatch.classList.add('selected');
  // Optional: Add custom styling
  
}

function initializeShowMoreSwatches() {
  // Get all "show more" links
  const showMoreLinks = document.querySelectorAll('#mit-show-hidden-swatches');
  
  showMoreLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Find the closest product container
      const productContainer = this.closest('[data-prod-id]');
      if (!productContainer) return;
      
      // Find all hidden swatches
      const hiddenSwatches = productContainer.querySelectorAll('[data-visible="hidden"]');
      
      // Show all hidden swatches
      hiddenSwatches.forEach(swatch => {
        swatch.dataset.visible = 'visible';
        swatch.style.display = 'inline-block';
      });
      
      // Hide the "show more" link
      this.style.display = 'none';
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function() {
    // Get the required elements
  const submitButtonGroup = document.querySelector(".product-form__controls-group--submit");
  const wishlistIcon = document.querySelector(".wishlist-hero-product-app-block");
  const productVariants = document.querySelector(".product-form__variants");
  
    if (submitButtonGroup && wishlistIcon && productVariants) {
        // Get the parent of the wishlist icon
        const wishlistParent = wishlistIcon.parentElement;
        
        // Create a new wrapper div
        const wrapperDiv = document.createElement("div");
        wrapperDiv.style.display = "flex";
        wrapperDiv.style.alignItems = "center";
        wrapperDiv.style.gap = "10px";
        
        // Create styled divs for layout
        const submitWrapper = document.createElement("div");
        submitWrapper.style.flex = "3"; // 75%
        submitWrapper.appendChild(submitButtonGroup);
        
        const wishlistWrapper = document.createElement("div");
        wishlistWrapper.style.flex = "0"; // 25%
        
        // Remove text from wishlist button, keeping only the SVG
        const wishlistButton = wishlistParent.querySelector("button");
        if (wishlistButton) {
            const wishlistSVG = wishlistButton.querySelector("svg");
            wishlistButton.innerHTML = ""; // Clear all content
            if (wishlistSVG) {
                wishlistButton.appendChild(wishlistSVG); // Re-add SVG only
            }
        }
        
        wishlistWrapper.appendChild(wishlistParent);
        
        // Append both elements to the wrapper
        wrapperDiv.appendChild(submitWrapper);
        wrapperDiv.appendChild(wishlistWrapper);
        
        // Insert the wrapper after product-form__variants
        productVariants.insertAdjacentElement("afterend", wrapperDiv);

      wishlistIcon.style.opacity = "1";
    }
  }, 1000)
  
});





      
 